import { Spinner, Text, makeStyles } from "@fluentui/react-components";

const useStyles = makeStyles({
  root: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100vh",
    gap: "16px",
  },
});

interface LoadingViewProps {
  message?: string;
}

export function LoadingView({ message = "Loading..." }: LoadingViewProps) {
  const styles = useStyles();

  return (
    <div className={styles.root}>
      <Spinner size="medium" />
      <Text size={200}>{message}</Text>
    </div>
  );
}
